/** Official enterprise support / inquiries (displayed across the web console). */
export const SUPPORT_EMAIL = 'yangzhoutech@realitypatch.net';
